import { useRouteRefParams } from '@backstage/frontend-plugin-api';
import { entityRouteRef } from '@backstage/plugin-catalog-react';
import { CloudResourcesContextProvider, PageType } from '../Providers';
import { ResourcesTab } from '../CatalogTabs';

/**
 * Account resources tab, per the resources page mockup: category filter
 * cards, stat strip, sync alert (with the error details dialog replacing the
 * old inline error card), faceted toolbar and grouped table.
 */
export const AccountCloudResourcesTab = () => {
  const { name } = useRouteRefParams(entityRouteRef);

  return (
    <CloudResourcesContextProvider
      pageType={PageType.ACCOUNT}
      entityName={name}
    >
      <ResourcesTab />
    </CloudResourcesContextProvider>
  );
};
